/**
 * Extracted from snippets/shoppay-banner.liquid (inline <script> at line 22).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at snippets/shoppay-banner.liquid:22) ---
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const banner = document.querySelector('.shoppay-banner');
    if (!banner) return;

    /*
     * Resolve THIS banner's own payment-terms widget, never `document`'s first.
     *
     * The cart drawer sits at body child index 9, BEFORE `main#main`, so it
     * precedes the product area in document order. Cart v2 gives the drawer a
     * Shop Pay line of its own, rendered from a cart form — so from the moment
     * the shopper has anything in their cart, `document.querySelector(
     * 'shopify-payment-terms')` on a product page returns the CART's widget and
     * this banner would quote the cart total instead of the product, and its
     * prequalify click would open the cart-scoped modal.
     *
     * `.product-info` contains exactly one widget, and the banner's own
     * previous sibling IS `payment-terms.product-info__payment-terms`, so
     * either scope resolves unambiguously. sections/ns-upgrade-fitness-offer-v2
     * already guards the same hazard with a section-scoped lookup.
     */
    const scope = banner.closest('.product-info') || document;
    const findTerms = function () {
      return scope.querySelector('shopify-payment-terms');
    };

    // Opens Shopify's (hidden) installments modal via its CTA. The trigger is the
    // prequalify link when present; otherwise (blank prequalify text) the whole
    // banner line acts as the clickable CTA.
    const cta = banner.querySelector('.prequalify-link') || banner.querySelector('.shoppay-banner-inner');
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        const paymentTermsEl = findTerms();
        if (paymentTermsEl && paymentTermsEl.shadowRoot) {
          const button = paymentTermsEl.shadowRoot.querySelector('#shopify-installments-cta');
          if (button) {
            button.click();
          } else {
            console.warn('Button not found in shadowRoot');
          }
        } else {
          console.warn('Element or shadowRoot not available');
        }
      });
    }

    // Eligibility gate: the banner is hidden by default (CSS). Reveal it ONLY
    // after we successfully scrape a real installment price out of Shopify's
    // <shopify-payment-terms> widget. If the buyer is ineligible (price below
    // threshold, region/credit ineligible) the widget renders no terms, so we
    // time out and the banner stays hidden instead of showing a broken half-line.
    const INTERVAL_MS = 300;
    const TIMEOUT_MS = 8000;
    let elapsed = 0;

    const poll = setInterval(function () {
      elapsed += INTERVAL_MS;

      const shadowHost = findTerms();
      const boldSpan = shadowHost && shadowHost.shadowRoot
        ? shadowHost.shadowRoot
            .querySelector('#shopify-installments-content')
            ?.querySelector('span.font-bold')
        : null;

      if (boldSpan && boldSpan.innerHTML.trim() !== '') {
        clearInterval(poll);
        const priceEl = banner.querySelector('#shoppay-price');
        if (priceEl) {
          priceEl.innerHTML = boldSpan.innerHTML;
        }
        banner.classList.add('is-eligible'); // reveal only on a real scraped price
        return;
      }

      if (elapsed >= TIMEOUT_MS) {
        clearInterval(poll);
        // No installment terms available -> banner stays hidden (display:none).
      }
    }, INTERVAL_MS);
  });
})();
